import { Theme } from '../contexts/ThemeContext';

export const getScoreColors = (theme: Theme, score: number, par: number) => {
    const isOverPar = score > par;
    const isPar = score === par;

    if (isPar) {
        return { bg: theme.colors.PAR, text: theme.colors.PAR_TEXT };
    } else if (isOverPar) {
        return { bg: theme.colors.OVER_PAR, text: theme.colors.OVER_PAR_TEXT };
    } else {
        return { bg: theme.colors.UNDER_PAR, text: theme.colors.UNDER_PAR_TEXT };
    }
};

export const getButtonColors = (theme: Theme, variant: 'primary' | 'secondary' | 'success' | 'error' = 'primary') => {
    const colors = {
        primary: { bg: theme.colors.BUTTON_PRIMARY_BG, text: theme.colors.BUTTON_PRIMARY_TEXT },
        secondary: { bg: theme.colors.BUTTON_SECONDARY_BG, text: theme.colors.BUTTON_SECONDARY_TEXT },
        success: { bg: theme.colors.BUTTON_SUCCESS_BG, text: theme.colors.BUTTON_SUCCESS_TEXT },
        error: { bg: theme.colors.BUTTON_ERROR_BG, text: theme.colors.BUTTON_ERROR_TEXT },
    };
    return colors[variant];
};

export const getInputStyles = (theme: Theme) => ({
    backgroundColor: theme.colors.INPUT_BACKGROUND,
    color: theme.colors.INPUT_TEXT,
    border: `1px solid ${theme.colors.INPUT_BORDER}`,
    borderRadius: '4px',
    padding: '8px',
    fontSize: 'inherit',
    '&:focus': {
        borderColor: theme.colors.INPUT_BORDER_FOCUS,
        outline: 'none',
    },
    '&::placeholder': {
        color: theme.colors.TEXT_SECONDARY,
        opacity: 1,
    },
});

export const getScoreRelativeToParColors = (theme: Theme, relativeToPar: string | null) => {
    if (!relativeToPar) return { bg: theme.colors.BACKGROUND, text: theme.colors.TEXT };
    if (relativeToPar === 'E') return { bg: theme.colors.PAR, text: theme.colors.PAR_TEXT };
    if (relativeToPar.startsWith('+')) return { bg: theme.colors.OVER_PAR, text: theme.colors.OVER_PAR_TEXT };
    return { bg: theme.colors.UNDER_PAR, text: theme.colors.UNDER_PAR_TEXT };
};

export const getScoreRelativeToParBorderRadius = (relativeToPar: string | null) => {
    if (!relativeToPar) return '4px';
    if (relativeToPar === 'E') return '4px';
    if (relativeToPar.startsWith('+')) return '4px';
    return '50%';
};

export const getScoreRelativeToParBorder = (theme: Theme, relativeToPar: string | null) => {
    if (relativeToPar === 'E') return `1px solid ${theme.colors.BORDER}`;
    return 'none';
};

export const getHighlightedItemStyle = (theme: Theme, isHighlighted: boolean) => ({
    backgroundColor: isHighlighted ? theme.colors.HIGHLIGHTED_ITEM : 'transparent'
}); 